import { arrondiCentime } from './arrondi.js';

// Progress toward the capital target for a due date (RG-13, resolves AMB-01 via D-003):
// min(100, round(projectedCapitalAtDate / objectifCapital * 100)); no target -> null.

/** Integer progress percentage, or null when there is no positive target. */
export function progressionVersObjectif(
  capitalProjete: number,
  objectifCapital: number | null | undefined,
): number | null {
  if (objectifCapital === null || objectifCapital === undefined || objectifCapital <= 0) {
    return null;
  }
  const ratio = (capitalProjete / objectifCapital) * 100;
  return Math.min(100, Math.round(ratio));
}

/** Latent gain = estimated capital minus total contributed (RG-08), rounded to the cent. */
export function plusValueLatente(capitalEstime: number, totalVerse: number): number {
  return arrondiCentime(capitalEstime - totalVerse);
}

/** Latent gain ratio = gain / total contributed, or null when nothing contributed. */
export function plusValuePct(plusValue: number, totalVerse: number): number | null {
  if (totalVerse <= 0) {
    return null;
  }
  return plusValue / totalVerse;
}
